var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('p',[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.$t('Page not found')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }